<div class="learning-container">
  <p-tabView [(activeIndex)]="activeTabIndex">
    <p-tabPanel *ngFor="let tab of learningTabs" [header]="tab.title">
      <ng-container [ngSwitch]="tab.key">
        
        <!-- Campaign Tab with Secure Video -->
        <ng-container *ngSwitchCase="'campaign'">
          <div class="video-container">
            <div class="secure-video-container">
              <div class="video-wrapper">
                <div class="security-overlay" (contextmenu)="preventAction($event)"></div>
                <video 
                  #videoPlayer
                  [src]="tab.videoUrl"
                  class="secure-video"
                  controlsList="nodownload nofullscreen noremoteplayback"
                  disablePictureInPicture
                  (contextmenu)="preventAction($event)"
                  (dragstart)="preventAction($event)"
                  (copy)="preventAction($event)"
                  (cut)="preventAction($event)"
                  (selectstart)="preventAction($event)"
                  (mousedown)="preventAction($event)"
                  preload="metadata"
                  playsinline>
                  Your browser does not support the video tag.
                </video>
                
                <!-- Custom Controls -->
                <div class="custom-controls" (contextmenu)="preventAction($event)">
                  <button (click)="togglePlayPause()" class="control-btn">
                    <i [class]="isPlaying ? 'pi pi-pause' : 'pi pi-play'"></i>
                  </button>
                  
                  <div class="progress-container">
                    <input 
                      type="range" 
                      class="progress-bar"
                      [value]="currentTime"
                      [max]="duration"
                      (input)="seek($event)"
                      (mousedown)="$event.stopPropagation()"
                    />
                    <span class="time-display">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
                  </div>
                  
                  <div class="volume-control">
                    <button (click)="toggleMute()" class="control-btn">
                      <i [class]="isMuted ? 'pi pi-volume-off' : 'pi pi-volume-up'"></i>
                    </button>
                    <input 
                      type="range" 
                      class="volume-slider"
                      min="0"
                      max="1"
                      step="0.1"
                      [value]="volume"
                      (input)="changeVolume($event)"
                      (mousedown)="$event.stopPropagation()"
                    />
                  </div>
                </div>
              </div>
              
              <!-- <div class="security-notice">
                <i class="pi pi-shield"></i>
                <span>This video is confidential and protected. Downloading, recording, or sharing is prohibited.</span>
              </div> -->
            </div>
          </div>
        </ng-container>

        <!-- Other Tabs Content -->
        <ng-container *ngSwitchDefault>
          <div class="tab-content">
            <h3>{{ tab.title }}</h3>
            <p>{{ tab.description }}</p>
            <div *ngIf="tab.videoUrl" class="coming-soon">
              <i class="pi pi-info-circle"></i>
              <span>Content coming soon...</span>
            </div>
          </div>
        </ng-container>
        
      </ng-container>
    </p-tabPanel>
  </p-tabView>
</div>